export const ONE_HOUR_IN_MS = 1000 * 60 * 60
export const ONE_DAY_IN_MS = 1000 * 60 * 60 * 24
export const ONE_WEEK_IN_MS = ONE_DAY_IN_MS * 7
export const NOVENA_IN_MS = ONE_DAY_IN_MS * 9
export const THIRTY_MINUTES_IN_MS = ONE_HOUR_IN_MS / 2
export const ONE_MONTH_IN_SECONDS = 60 * 60 * 24 * 30
